import styled from '@emotion/styled';
import { Text, Modal, Button, tokens } from '@hotjar/hotsauce';

const StyledList = styled.ol`
  margin-top: ${tokens.spacer.x1pt5};
  padding-left: ${tokens.spacer.x3};
  ${tokens.text('body1')};
`;

export interface RetakerHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RetakerHelpModal = ({ isOpen, onClose }: RetakerHelpModalProps): JSX.Element => (
  <Modal
    size="s"
    isOpen={isOpen}
    contentLabel="Screenshot retake confirmation message"
    onClose={onClose}
  >
    <Modal.Header title="Take a new screenshot" />
    <Modal.Body>
      <Text as="p" textType="body1">
        Capture the moment that most accurately reflects your page.
      </Text>
      <StyledList>
        <li>Find what you want to screenshot using the timeline</li>
        <li>Pause the recording</li>
        <li>Press “Take new screenshot”</li>
      </StyledList>
    </Modal.Body>
    <Modal.Footer>
      <Button kind="primary" onClick={onClose}>
        Ok, got it
      </Button>
    </Modal.Footer>
  </Modal>
);
